import CommonTable from 'components/table/CommonTable';
import { useTranslation } from 'react-i18next';
import useTable from 'components/table/hooks/useTable';
import useFetchGuestReviewTemplates from 'components/domain/review/useFetchGuestReviewTemplates';
import { createColumnHelper } from '@tanstack/react-table';
import { GuestReviewTemplate } from 'models/automation/Reviews';
import ActionsCell from './cells/ActionsCell';

const GuestReviewTemplatesTable = () => {
  const { t } = useTranslation();

  const { data: reviewTemplates, isFetching } = useFetchGuestReviewTemplates();

  const columnHelper = createColumnHelper<GuestReviewTemplate>();

  const columns = [
    columnHelper.accessor('title', {
      header: t(
        'pageAutomations.reviews.guestReviewTemplates.table.reviewTemplateTitle',
      ),
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const tableInstance = useTable({
    data: reviewTemplates ?? [],
    columns,
    manualPagination: true,
    pageCount: 1,
  });

  return (
    <CommonTable
      data-testid="guest-review-templates-table"
      tableInstance={tableInstance}
      isLoading={isFetching}
      emptyState={t(
        'pageAutomations.reviews.guestReviewTemplates.table.emptyTable',
      )}
    />
  );
};

export default GuestReviewTemplatesTable;
